import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { VirtualSearchPayload } from '@/types/virtual-search';
import { formatAggregationFilters } from '@/helpers/virtual-search';
import { useVirtualSearch } from '@/composables/virtual-search';
import { HblEntity } from '@/types/hbl/hbl.entity';
import HouseService from '@/services/house.service';
import { HblVirtualFilterDefaultForm } from '@/constants/virtual-search/import/hbl';

export const useVirtualHblStore = defineStore('Virtual-HBL', () => {
  const filterForm = ref(HblVirtualFilterDefaultForm());
  const tabletSearchQuery = ref('');
  const isTabletView = ref(false);

  const options = computed<VirtualSearchPayload<HblEntity>>(() => ({
    chunkSize: 15,
    ...formatAggregationFilters(filterForm.value),
    ...(isTabletView.value && {
      isTabletView: true,
      tabletQuery: tabletSearchQuery.value,
    }),
  }));

  const { items, aggregations, isFetching, fetchedAllItems, search, response, total } =
    useVirtualSearch(HouseService.virtualSearch, options);

  const resetFilters = async () => {
    filterForm.value = HblVirtualFilterDefaultForm();
    tabletSearchQuery.value = '';
  };

  const setTabletSearch = (query: string) => {
    tabletSearchQuery.value = query;
    isTabletView.value = true;
  };

  const setDesktopView = () => {
    isTabletView.value = false;
    tabletSearchQuery.value = '';
  };

  return {
    options,
    filterForm,
    items,
    aggregations,
    isFetching,
    fetchedAllItems,
    search,
    total,
    response,
    resetFilters,
    tabletSearchQuery,
    isTabletView,
    setTabletSearch,
    setDesktopView,
  };
});
